import React from 'react';
import ToolTip from '../ToolTip';

export const TextInput = (props) => (
	<label className={props.labelClass} htmlFor={props.name}>
		<span className="label">
            {props.label}
            {props.required ? ('*') : (false)}
            {props.info ? (
                <ToolTip
                    title={props.title} 
                    info={props.info} />
            ) : ( false )}
        </span>
    	<input 
    		id={props.id}
    		className={props.className} 
    		type={props.type || "text"} 
    		name={props.name} 
    		placeholder={props.placeholder} 
    		value={props.value}
            maxLength={props.maxLength}
            max={props.maxVal}
    		onChange={props.onChange} />
    	<span className="form-error">
    		<p>{props.errMessage}</p>
    	</span>
	</label>
);


// WEBPACK FOOTER //
// ./src/components/BasicForm/TextInput.js